<template>
  <div class="tool-card" :class="{ 'is-error': step.is_error }">
    <div class="head" @click="sqlOpen = !sqlOpen">
      <div class="status">
        <b-spinner v-if="!step.finished" small/>
        <feather v-else-if="step.is_error" type="x-circle" size="14"/>
        <feather v-else type="check-circle" size="14"/>
      </div>
      <div class="title">
        <span v-if="!step.finished">Выполняю запрос...</span>
        <span v-else-if="step.is_error">SQL ошибка</span>
        <span v-else>{{ rowsLabel }} · {{ step.elapsed_ms }} мс</span>
      </div>
      <span class="toggle">
        {{ sqlOpen ? 'скрыть SQL' : 'показать SQL' }}
      </span>
    </div>

    <pre v-if="sqlOpen" class="sql hljs"><code v-html="highlightedQuery"/></pre>

    <div v-if="step.is_error" class="error-msg">
      {{ step.error_message }}
    </div>

    <div v-if="step.finished && !step.is_error && step.rows && step.rows.length" class="data-block">
      <button class="link-btn" @click="dataOpen = !dataOpen">
        {{ dataOpen ? 'скрыть данные' : 'показать данные' }}
      </button>
      <div v-if="dataOpen" class="table-wrap">
        <table class="data-table">
          <thead>
          <tr>
            <th v-for="col in step.columns" :key="col">{{ col }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(row, i) in displayedRows" :key="i">
            <td v-for="col in step.columns" :key="col">{{ formatCell(row[col]) }}</td>
          </tr>
          </tbody>
        </table>
        <div v-if="step.rows.length > maxRows" class="more">
          Показано {{ maxRows }} из {{ step.total_rows || step.rows.length }} строк
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { highlightSql } from '@/common/sqlHighlight';

export default {
  name: 'ToolCallCard',
  props: {
    step: { type: Object, required: true },
  },
  data() {
    return {
      sqlOpen: false,
      dataOpen: false,
      maxRows: 50,
    };
  },
  computed: {
    highlightedQuery() {
      return highlightSql(this.step.query || '');
    },
    rowsLabel() {
      const total = this.step.total_rows ?? (this.step.rows ? this.step.rows.length : 0);
      return `${total} ${this.pluralRu(total)}`;
    },
    displayedRows() {
      return (this.step.rows || []).slice(0, this.maxRows);
    },
  },
  methods: {
    pluralRu(n) {
      const mod10 = n % 10;
      const mod100 = n % 100;
      if (mod100 >= 11 && mod100 <= 14) return 'строк';
      if (mod10 === 1) return 'строка';
      if (mod10 >= 2 && mod10 <= 4) return 'строки';
      return 'строк';
    },
    formatCell(v) {
      if (v === null || v === undefined) return '—';
      if (typeof v === 'object') return JSON.stringify(v);
      return v;
    },
  },
};
</script>

<style scoped lang="scss">
.tool-card {
  border: 1px solid var(--ai-border);
  border-radius: 10px;
  background: var(--ai-bg);
  padding: 10px 12px;
  margin: 6px 0;
  font-size: 13px;
  color: var(--ai-text);

  &.is-error {
    border-color: #fca5a5;
    background: #fef2f2;
  }
}

.head {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
}
.status {
  width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--ai-text-muted);

  .is-error & { color: #b91c1c; }
}
.title {
  flex: 1;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.toggle {
  font-size: 11.5px;
  color: var(--ai-text-muted);
  text-transform: lowercase;
}

.sql {
  margin: 8px 0 0;
  padding: 10px 12px;
  background: #0d1117;
  border-radius: 8px;
  font-size: 12.5px;
  font-family: var(--ai-font-mono);
  white-space: pre-wrap;
  word-break: break-word;
  overflow-x: auto;

  code { background: transparent; }
}

.error-msg {
  margin-top: 8px;
  color: #b91c1c;
  font-size: 12.5px;
}

.data-block { margin-top: 8px; }

.link-btn {
  background: transparent;
  border: none;
  padding: 0;
  color: var(--ai-text-muted);
  font-size: 12px;
  cursor: pointer;
  &:hover { color: var(--ai-text); }
}

.table-wrap {
  margin-top: 6px;
  max-height: 320px;
  overflow: auto;
  border: 1px solid var(--ai-border);
  border-radius: 8px;
}
.data-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12.5px;

  th, td {
    padding: 6px 10px;
    border-bottom: 1px solid var(--ai-border);
    text-align: left;
  }
  th {
    background: var(--ai-user-bubble);
    font-weight: 600;
    position: sticky;
    top: 0;
  }
  tr:last-child td { border-bottom: none; }
}
.more {
  padding: 6px 10px;
  font-size: 11.5px;
  color: var(--ai-text-muted);
  background: var(--ai-user-bubble);
}
</style>
